import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import Swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import { AuthenticationService } from "app/auth/service";
import { Router, ActivatedRoute } from "@angular/router";
import { CoreSidebarService } from "@core/components/core-sidebar/core-sidebar.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from 'app/_services/customer.service';
import { OutstandingReportService } from 'app/_services/outstanding-report.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit {
  public customerList: any = [];
  public start: any = 0;
  public page: any = 0;

  public sidebarToggleRef = false;
  public contentHeader: object;
  public pageBasicText = 1;
  public collectionSize = 0;
  public lengths = 15;
  public loading = false;
  public progressMainTable: boolean = false;
  public newFormAdd: FormGroup;
  public submitted = false;
  public isAddMode: boolean = true;
  public loadingFrm: boolean = false;
  public customerId = 0;
  public error = "";
  public customerOutStanding: any = [];
  public customerOpeningBalance: any;
  public cust_name: any;
  public loadingReport: boolean = false;
  public currentUser: any;
  public tempUser: any;
  public user_id:any = 0;
  
  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private CustomerService: CustomerService,
    private outstandingReportService: OutstandingReportService,
    private _authenticationService: AuthenticationService,
    private _formBuilder: FormBuilder,
    private _toastrService: ToastrService,
    private http: HttpClient,
    private modalService: NgbModal,
    private _coreSidebarService: CoreSidebarService
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.tempUser = JSON.parse(localStorage.getItem('tempUser'));
    
    if(this.currentUser.user.id != this.tempUser){
      this.user_id = this.tempUser;
    }else{
      this.user_id = this.currentUser.user.id;
    }
    this.customersList(this.start, this.lengths,this.user_id);
    this.newFormAdd = this._formBuilder.group({
      name: ["", Validators.required],
      mobile: ["", Validators.required],
      email: [""],
      address: [""],
    });
  }

  get f() {
    return this.newFormAdd.controls;
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.newFormAdd.invalid) {
      this.newFormAdd.markAllAsTouched();
    } else {
      this.loadingFrm = true;
      this.error = "";
      const { name,mobile,email,address } = this.newFormAdd.controls;
      this.CustomerService.add(
        name.value,
        mobile.value,
        email.value,
        address.value,
        this.customerId,
        this.user_id
      ).subscribe(
        (data) => {
          this.loadingFrm = false;
          if (data.status) {
            this.customerId = 0;
            this.submitted = false;
            this.newFormAdd.reset();
            this.toggleSidebar("new-sidebar");
            this._toastrService.success(data.message, "Success!", {
              toastClass: "toast ngx-toastr",
              closeButton: true,
            });
            this.reloadList();
          } else {
            this.error = data.message;
          }
        },
        (err) => {
          if (err.error.error == "Unauthenticated.") {
            this._authenticationService.logout();
            this._router.navigate(["/login"]);
          }
        }
      );
    }
  }

  toggleSidebar(name, type: any = 0): void {
    if (type == 0) {
      this.customerId = 0;
    }
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  customersList(my_start: any, my_lengths: any,my_user_id:any) {
    this.CustomerService.getData(my_start, my_lengths,my_user_id).subscribe(
      (response) => {
        this.loading = false;
        this.progressMainTable = false;
        if (response.status) {
          this.customerList = response.data;
          this.collectionSize = response.recordsTotal;
        }
      },
      (err) => {
        if (err.error.error == "Unauthenticated.") {
          this._authenticationService.logout();
          this._router.navigate(["/login"]);
        }
      }
    );
  }

  reloadList() {
    this.progressMainTable = true;
    this.customersList(this.page, this.lengths,this.user_id);
  }

  loadPage(event: any) {
    this.progressMainTable = true;
    this.page = this.lengths * (event - 1);
    this.customersList(this.page, this.lengths,this.user_id);
  }
  loadPageLenghs(event: any) {
    this.progressMainTable = true;
    this.lengths = event.target.value;
    this.customersList(this.start, this.lengths,this.user_id);
  }

  edit(index: any) {
    this.customerId = this.customerList[index].id;
    this.f.name.setValue(this.customerList[index].name);
    this.f.mobile.setValue(this.customerList[index].mobile);
    this.f.email.setValue(this.customerList[index].email);
    this.f.address.setValue(this.customerList[index].address);

    this.toggleSidebar("new-sidebar", 1);
  }

  delete(id: any) {
    const me = this;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#7367F0",
      cancelButtonColor: "#E42728",
      confirmButtonText: "Yes, delete it!",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger ml-1",
      },
    }).then(function (result) {
      if (result.value) {
        me.CustomerService.delete(id).subscribe(
          (response) => {
            if (response.status) {
              me.progressMainTable = true;
              me.reloadList();
              Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: "Customer Deleted Successfully",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            }
          },
          (err) => {
            if (err.error.error == "Unauthenticated.") {
              this._authenticationService.logout();
              this._router.navigate(["/login"]);
            }
          }
        );
      }
    });
  }

  details(customer: any,modalSM) {
    if (customer.id > 0) {
      this.loadingReport = true;
      this.customerOpeningBalance = '';
      this.customerOutStanding = [];
      this.modalService.open(modalSM, {
        centered: true,
        size: 'xl'
      });
      this.cust_name = customer.name;
      this.outstandingReportService.loadOutStandingReport(customer.id).subscribe(
        data => {
          // this.loadingReport = false;
          if (data.status) {
            let total = 0;
            if (data.opening_balance.balance_type == 'D') {
              total = -data.opening_balance.balance;
            }
            else {
              total = data.opening_balance.balance;
            }
            data.data.forEach((value: any, index: any) => {
              if (value.payment_type == "C") {
                total += parseFloat(value.amount);
              }
              else {
                total -= parseFloat(value.amount);
              }
              data.data[index].closing = total;
            });

            this.customerOpeningBalance = data.opening_balance;
            this.customerOutStanding = data.data;

          }
        },
        err => {
          if (err.error.error == 'Unauthenticated.') {
            this._authenticationService.logout();
            this._router.navigate(['/login']);
          }
          this._toastrService.clear();
          this._toastrService.error(err.errorMessage, 'Opps!', { toastClass: 'toast ngx-toastr', closeButton: true });
          this.customerOpeningBalance = '';
          this.customerOutStanding = [];
          this.loadingReport = false;
        }
      );

    }
  }

  downloadExcelData() {
    this.CustomerService.fileDownload(this.user_id).subscribe(
      (data) => {
        window.location.href=data.url;
      },
      (error) => {
        this._toastrService.error('Something went wrong! Please Try Againg...', 'Opps!', { toastClass: 'toast ngx-toastr', closeButton: true });
      }
    );
  }
}
